import React from 'react'
// libs
import { useMutation } from '@apollo/client/react'
// components
import { Button } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
// views
import { EyeIcon, EyeSelectedIcon } from './views'
// themes
import { colors } from 'themes/index'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
import { LogicalConditionsContext } from 'containers/Risks/RiskTemplate/Edit/layers/LogicalConditions'
// types
import { IField, RiskTemplateFormConditionActionType } from 'types/graphql'
// graphql
import { FIELD_UPDATE_MUTATION } from 'graphql/objects/mutations'
// utils
import { parseGraphQLErrorMessages } from 'utils/errors/parsers'

interface Props {
  field: IField
}

const VisibilityButton: React.FC<Props> = ({ field }) => {
  const [updateField] = useMutation(FIELD_UPDATE_MUTATION)

  const { refetchTemplate } = React.useContext(RiskTemplateAPIContext)

  const { currentCondition, onFieldVisibilityChange } = React.useContext(LogicalConditionsContext)

  const fieldCondition = currentCondition?.actions?.find(
    (action) => action.fieldId === field.id && action.type === RiskTemplateFormConditionActionType.Visibility
  )

  const hidden = fieldCondition ? fieldCondition?.value : field.hidden

  const onVisibilityClick = async () => {
    if (currentCondition) {
      onFieldVisibilityChange?.(field.id, !fieldCondition?.value)
    } else {
      try {
        await updateField({
          variables: {
            id: field.id,
            input: {
              hidden: !field.hidden
            }
          }
        })

        refetchTemplate()
      } catch (e) {
        console.log('[VisibilityButton.onVisibilityClick]: ', parseGraphQLErrorMessages(e))
      }
    }
  }

  const isCurrentField = currentCondition?.fieldId === field.id

  return (
    <Button onClick={onVisibilityClick} disabled={isCurrentField}>
      {hidden ? (
        <EyeIcon color={fieldCondition ? colors.purple300 : colors.blue500} />
      ) : (
        <EyeSelectedIcon color={fieldCondition ? colors.purple300 : colors.blue500} />
      )}
    </Button>
  )
}

export default VisibilityButton
